import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2whx95n6vnccj">
    <p className="font-display text-xl font-semibold italic leading-relaxed text-brand-sageMid md:text-3xl" data-id="element-1" data-mp="28te2fc3h77mk">
      🌸 Tu próxima tandada empieza con criterio, no con improvisación.
    </p>
  </div>;
export function App({
  showSocialProofToast = true
}: {
  showSocialProofToast?: boolean;
}) {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Cosmética Natural — La Guía Definitiva',
      content_type: 'product',
      value: 24990,
      currency: 'ARS'
    });
  }, []);
  return <div className="min-h-screen w-full bg-brand-cream font-display text-brand-text selection:bg-brand-sageMist selection:text-brand-sageDeep" data-id="element-2" data-mp="82kl3wchwbg">
      <UrgencyBanner data-id="element-3" data-mp="33m5e4aq9pybi" />
      <main data-id="element-4" data-mp="33ngee0ki8nxv">
        <Hero data-id="element-5" data-mp="33n6wl09m5n39" />
        <PackContents data-id="element-6" data-mp="33orjc3pos1qk" />
        <InitialTestimonials data-id="element-7" data-mp="38m1g64fenfof" />
        <PainPoints data-id="element-8" data-mp="38kqc03i1s5ws" />
        <LaunchOffer data-id="element-9" data-mp="38k6vmr81ppkv" />
        <MoreTestimonials data-id="element-10" data-mp="38num1hi71vvd" />
        <FAQ data-id="element-11" data-mp="3dkl0k0ecojeo" />
        <CostComparison data-id="element-12" data-mp="3dl4l7ovdxlwe" />
        <TransitionPhrase data-id="element-13" data-mp="3dmfprqwnmxok" />
        <EmotionalClose data-id="element-14" data-mp="3dii3iwes5q0g" />
      </main>
      <Footer data-id="element-15" data-mp="nw2egcoye2u9" />
      {showSocialProofToast && <FloatingNotification data-id="element-16" data-mp="nvaq9mxor7e0" />}
    </div>;
}